import clsx from 'clsx'

// Thin wrapper around clsx so call sites don't need to know which utility
// we picked. All Tailwind classes in this kit use the `tw-` prefix
// configured in tailwind.config.js.
export const cn = (...args) => clsx(...args)
